import React from "react";

interface Props {
  size?: number;
  color?: string;
}
const SickDayIcon: React.FC<Props> = ({ color = "#2D9CDB", size = 14 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.97301 5.83335L10.7313 6.59169M8.10634 7.70002L8.86468 8.45835M6.23384 9.57194L6.99276 10.3303M7.76043 2.91669L8.23876 2.43835C8.45693 2.22015 8.71594 2.04705 9.00101 1.92894C9.28607 1.81083 9.59161 1.75003 9.90018 1.75C10.2087 1.74997 10.5143 1.81072 10.7994 1.92878C11.0845 2.04684 11.3435 2.21989 11.5617 2.43806C11.7799 2.65623 11.953 2.91524 12.0711 3.20031C12.1892 3.48538 12.25 3.79092 12.2501 4.09948C12.2501 4.40805 12.1893 4.71359 12.0713 4.99868C11.9532 5.28377 11.7802 5.54281 11.562 5.76102L6.34584 10.9778C6.15896 11.1647 5.93241 11.3071 5.683 11.3946C5.43358 11.482 5.16768 11.5122 4.90501 11.4829L4.43834 11.431C4.26325 11.4115 4.086 11.4316 3.91977 11.49C3.75354 11.5484 3.60261 11.6435 3.47818 11.7682L3.25476 11.9922C3.17291 12.074 3.07574 12.139 2.96879 12.1833C2.86185 12.2276 2.74722 12.2504 2.63147 12.2504C2.51571 12.2504 2.40109 12.2276 2.29414 12.1833C2.1872 12.139 2.09003 12.074 2.00818 11.9922C1.92632 11.9103 1.8614 11.8132 1.8171 11.7062C1.7728 11.5993 1.75 11.4847 1.75 11.3689C1.75 11.2531 1.7728 11.1385 1.8171 11.0316C1.8614 10.9246 1.92632 10.8275 2.00818 10.7456L2.23218 10.5222C2.35698 10.3977 2.45212 10.2467 2.51049 10.0803C2.56886 9.91398 2.58898 9.73662 2.56934 9.56144L2.51684 9.09535C2.48764 8.83263 2.51794 8.56671 2.60549 8.31729C2.69304 8.06787 2.83559 7.84135 3.02259 7.65452L6.01043 4.66669"
        stroke={color}
        stroke-width="0.84"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.25 8.75L8.75 5.25"
        stroke={color}
        stroke-width="0.84"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default SickDayIcon;
